import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from "../../shared";


// https://api.akaun.cloud/core2/tnt/dm/erp/entity-customer-employee-import-file-helper

@Injectable({
  providedIn: 'root'
})
export class CustomerEmployeeFileHelperService extends BaseApiTemplateService<any> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-customer-employee-import-file-helper/backoffice-ep'
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-customer-employee-import-file-helper/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-customer-employee-import-file-helper/backoffice-ep';
        this.httpClient = http;
    }

}
